import React, { useContext, useEffect, useReducer } from "react";
import { Helmet } from "react-helmet-async";
import axiosInstance from "../Util";
import { useNavigate } from "react-router-dom";
import LoadingBox from "../Components/LoadingBox";
import MessageBox from "../Components/MessageBox";
import { Store } from "../Store";
import { getError } from "../Util";
import { Button } from "react-bootstrap";

const reducer = (state, action) => {
  switch (action.type) {
    case "FETCH_REQUEST":
      return { ...state, loading: true };
    case "FETCH_SUCCESS":
      return { ...state, orders: action.payload, loading: false };
    case "FETCH_FAIL":
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default function OrderHistoryPage() {
  const { state } = useContext(Store);
  const { userInfo } = state;
  const navigate = useNavigate();

  const [{ loading, error, orders }, dispatch] = useReducer(reducer, {
    loading: true,
    error: "",
  });

  useEffect(() => {
    const fetchData = async () => {
      dispatch({ type: "FETCH_REQUEST" });
      try {
        const { data } = await axiosInstance.get(`/api/orders/mine`, {
          headers: { Authorization: `Bearer ${userInfo.token}` },
        });
        dispatch({ type: "FETCH_SUCCESS", payload: data });
      } catch (error) {
        dispatch({
          type: "FETCH_FAIL",
          payload: getError(error),
        });
      }
    };
    fetchData();
  }, [userInfo]);

  const isPaid = (order) => {
    return order.isPaid ? "text-success" : "text-danger";
  };

  const isDelivered = (order) => {
    return order.isDelivered ? "text-success" : "text-danger";
  };

  return (
    <div>
      <Helmet>
        <title>Order History</title>
      </Helmet>

      <h1 className='mb-3'>Order History</h1>
      {loading ? (
        <LoadingBox></LoadingBox>
      ) : error ? (
        <MessageBox variant='danger'>{error}</MessageBox>
      ) : (
        <div className='table-responsive'>
          <table className='table table-bordered table-striped table-hover'>
            <thead className='table-primary'>
              <tr>
                <th>Order ID</th>
                <th>Details</th>
                <th>Paid</th>
                <th>Delivered</th>
                <th>DATE</th>
                <th>TOTAL</th>
              </tr>
            </thead>
            <tbody>
              {orders.map((order) => (
                <tr key={order._id}>
                  <td>{order._id}</td>
                  <td>
                    <Button
                      type='button'
                      variant='primary'
                      onClick={() => {
                        navigate(`/order/${order._id}`);
                      }}
                    >
                      View details
                    </Button>
                  </td>
                  <td className={isPaid(order)}>
                    {order.isPaid ? "Paid" : "Unpaid"}
                  </td>
                  <td className={isDelivered(order)}>
                    {order.isDelivered ? "Delivered" : "Undelivered"}
                  </td>
                  <td s>{order.createdAt.substring(0, 10)}</td>
                  <td>{order.totalPrice.toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
